/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_TaiyoroInputs */

const ja_home_brands_taiyoro = /** @type {(inputs: Home_Brands_TaiyoroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taiyoro`)
};

const en_home_brands_taiyoro = /** @type {(inputs: Home_Brands_TaiyoroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taiyoro`)
};

/**
* | output |
* | --- |
* | "Taiyoro" |
*
* @param {Home_Brands_TaiyoroInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_taiyoro = /** @type {((inputs?: Home_Brands_TaiyoroInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_TaiyoroInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_taiyoro(inputs)
	return en_home_brands_taiyoro(inputs)
});